export default {
  title: "Welcome to your new Ulsemo store",
  message: `We are very happy you decided to start your online business on Ulsemo! We prepared a quick guide for you to enable a
  quick and easy set up.<br/><br/><b>Are you here to create a full store or to sell solely on Ulsemo marketplace?</b>`,
  marketplace_button: "Just marketplace",
  full_button: "Full store",
}
